var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_2229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.805 342.391H110.966C94.4226 342.391 80.999 329.004 80.999 312.476C80.999 295.961 94.4085 282.561 110.966 282.561H185.805C202.348 282.561 215.772 295.947 215.772 312.476C215.772 328.99 202.362 342.391 185.805 342.391Z",
    fill: "#E8E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.452 314.209C167.653 311.982 159.96 310.545 151.265 310.545C142.57 310.545 134.877 311.997 130.078 314.209H124.926V319.549C124.926 324.523 136.726 328.553 151.265 328.553C165.804 328.553 177.604 324.523 177.604 319.549V314.209H172.452Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.265 323.213C165.812 323.213 177.604 319.182 177.604 314.209C177.604 309.236 165.812 305.205 151.265 305.205C136.718 305.205 124.926 309.236 124.926 314.209C124.926 319.182 136.718 323.213 151.265 323.213Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.471 313.589C168.471 316.491 160.764 318.859 151.264 318.859C141.765 318.859 134.058 316.506 134.058 313.589C134.058 310.672 141.765 308.319 151.264 308.319C160.764 308.319 168.471 310.672 168.471 313.589Z",
    stroke: "white",
    strokeWidth: 1.14905,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.452 305.205C167.653 302.978 159.96 301.541 151.265 301.541C142.57 301.541 134.877 302.992 130.078 305.205H124.926V310.545C124.926 315.519 136.726 319.549 151.265 319.549C165.804 319.549 177.604 315.519 177.604 310.545V305.205H172.452Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.265 314.209C165.812 314.209 177.604 310.177 177.604 305.205C177.604 300.232 165.812 296.2 151.265 296.2C136.718 296.2 124.926 300.232 124.926 305.205C124.926 310.177 136.718 314.209 151.265 314.209Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.471 304.585C168.471 307.487 160.764 309.855 151.264 309.855C141.765 309.855 134.058 307.501 134.058 304.585C134.058 301.668 141.765 299.315 151.264 299.315C160.764 299.315 168.471 301.668 168.471 304.585Z",
    stroke: "white",
    strokeWidth: 1.14905,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.452 296.201C167.653 293.974 159.96 292.537 151.265 292.537C142.57 292.537 134.877 293.988 130.078 296.201H124.926V301.541C124.926 306.515 136.726 310.545 151.265 310.545C165.804 310.545 177.604 306.515 177.604 301.541V296.201H172.452Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.265 305.205C165.812 305.205 177.604 301.174 177.604 296.201C177.604 291.228 165.812 287.197 151.265 287.197C136.718 287.197 124.926 291.228 124.926 296.201C124.926 301.174 136.718 305.205 151.265 305.205Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.471 295.595C168.471 298.497 160.764 300.865 151.264 300.865C141.765 300.865 134.058 298.512 134.058 295.595C134.058 292.678 141.765 290.325 151.264 290.325C160.764 290.325 168.471 292.678 168.471 295.595Z",
    stroke: "white",
    strokeWidth: 1.14905,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.452 287.197C167.653 284.97 159.96 283.533 151.265 283.533C142.57 283.533 134.877 284.984 130.078 287.197H124.926V292.537C124.926 297.511 136.726 301.541 151.265 301.541C165.804 301.541 177.604 297.511 177.604 292.537V287.197H172.452Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.604 287.197C177.604 292.171 165.804 296.201 151.265 296.201C136.726 296.201 124.926 292.171 124.926 287.197C124.926 282.223 136.726 278.193 151.265 278.193C165.804 278.193 177.604 282.223 177.604 287.197Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.471 286.591C168.471 289.493 160.764 291.861 151.264 291.861C141.765 291.861 134.058 289.507 134.058 286.591C134.058 283.674 141.765 281.321 151.264 281.321C160.764 281.321 168.471 283.674 168.471 286.591Z",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07 277.206C168.329 273.472 161.596 269.484 153.438 266.497C145.265 263.51 137.544 262.242 132.279 262.678L127.438 260.917L125.603 265.933C123.895 270.597 133.578 278.432 147.255 283.42C160.919 288.408 173.383 288.662 175.091 283.998L176.926 278.982L172.084 277.22L172.07 277.206Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.913 278.982C175.205 283.646 162.741 283.393 149.077 278.404C135.414 273.416 125.717 265.596 127.425 260.918C129.133 256.253 141.596 256.507 155.26 261.495C168.923 266.483 178.621 274.304 176.913 278.982Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.556 275.276C167.554 278.01 159.508 277.587 150.587 274.318C141.666 271.063 135.23 266.202 136.232 263.468C137.234 260.734 145.28 261.157 154.2 264.426C163.121 267.681 169.558 272.543 168.556 275.276Z",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.01 229.833C164.731 229.509 157.038 230.96 148.95 234.13C140.848 237.301 134.214 241.444 130.558 245.262L125.759 247.136L127.707 252.096C129.528 256.718 141.977 256.183 155.528 250.884C169.079 245.586 178.578 237.54 176.771 232.904L174.823 227.944L170.024 229.819L170.01 229.833Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.809 227.945C176.63 232.566 167.117 240.626 153.566 245.925C140.015 251.223 127.566 251.772 125.745 247.136C123.924 242.501 133.438 234.455 146.988 229.156C160.539 223.858 172.989 223.309 174.809 227.945Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.086 230.706C167.144 233.412 160.835 238.414 151.985 241.88C143.134 245.347 135.103 245.953 134.03 243.247C132.971 240.542 139.281 235.539 148.131 232.073C156.981 228.607 165.013 228.001 166.086 230.706Z",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.691 193.901C163.586 204.497 147.594 205.723 136.979 196.635C126.364 187.546 125.136 171.581 134.241 160.985C143.331 150.388 159.324 149.162 169.938 158.251C180.553 167.34 181.781 183.305 172.677 193.901H172.691Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.403 200.101C164.388 200.101 175.726 188.783 175.726 174.822C175.726 160.861 164.388 149.543 150.403 149.543C136.417 149.543 125.08 160.861 125.08 174.822C125.08 188.783 136.417 200.101 150.403 200.101Z",
    fill: "#F9DD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.213 167.142C169.177 173.244 168.443 180.782 163.743 186.25C157.419 193.605 146.325 194.465 138.942 188.152C131.574 181.839 130.713 170.764 137.037 163.394C138.434 161.76 140.071 160.449 141.85 159.463",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.063 161.689C162.713 162.267 163.306 162.873 163.856 163.521",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.216 157.688C155.529 157.983 156.813 158.42 158.041 159.012",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2027 331.837C97.2027 331.837 93.8715 349.394 115.397 357.581C115.397 357.581 107.295 350.155 113.703 332.006L97.2027 331.837Z",
    fill: "#F5EEEB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_668_2229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.387 197.439H390.697V219.332H261.387V197.439Z",
    fill: "#AFA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.876 225.754H346.973V239.386H278.876V225.754Z",
    stroke: "#AFA6FF",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.387 197.439H287.803V219.332H261.387V197.439Z",
    fill: "#E2663D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84 160.307C323.919 155.965 326.048 137.483 326.048 137.483C326.048 137.483 328.176 155.965 345.255 160.307C328.176 164.649 326.048 183.131 326.048 183.131C326.048 183.131 323.919 164.649 306.84 160.307Z",
    stroke: "#AFA6FF",
    strokeWidth: 2.41905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.509 129.9C196.509 129.9 172.548 121.978 160.876 128.364C149.204 134.75 134.121 151.466 134.121 151.466C134.121 151.466 146.289 157.187 163.331 141.596L180.616 145.225L198.456 157.707C198.456 157.707 200.936 169.439 193.63 177.338C193.63 177.338 167.081 174.604 160.828 187.522C160.828 187.522 231.73 201.117 246.692 188.296C265.391 172.27 211.495 134.847 196.485 129.912L196.509 129.9Z",
    fill: "#EDD6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.965 188.562C189.965 188.562 229.456 196.436 246.716 188.284C246.716 188.284 284.453 156.582 282.385 154.163C280.316 151.744 257.493 118.144 237.608 109.798C217.724 101.452 212.281 109.459 212.281 109.459C212.281 109.459 201.044 110.064 198.226 118.059C198.226 118.059 184.994 120.684 185.345 132.053L210.781 161.445L189.977 188.574L189.965 188.562Z",
    fill: "#EDD6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.779 120.333L206.004 122.438",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.587 110.79L220.106 112.931",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.083 126.211L193.292 127.892",
    stroke: "#FF7362",
    strokeWidth: 1.20952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.192 149.906L293.67 163.779L253.115 206.148L233.895 189.663L279.192 149.906Z",
    fill: "#EDD6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.892 159.135L247.007 208.52L256.465 217.639L300.697 166.815L291.892 159.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.697 166.815C300.697 166.815 325.432 188.018 327.331 222.247L269.818 279.76C269.818 279.76 270.592 249.316 249.317 223.287L300.685 166.815H300.697Z",
    fill: "#6840FD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_2229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 279,
    height: 254,
    fill: "white",
    transform: "translate(81 106)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_668_2229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.689,
    height: 183.473,
    fill: "white",
    transform: "matrix(-1 0 0 1 390.698 106)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg3);
export default __webpack_public_path__ + "static/media/about_img3.6dc182a742513173e8f15b9747d5ff7e.svg";
export { ForwardRef as ReactComponent };